import { useMutation } from "@tanstack/react-query";
import { sendPlanInquiryMail } from "app/api/send_mail";

const useSendPlanInquiryMail = ({ onSuccess, onError }) => {
  return useMutation({
    mutationFn: async ({ name, email, plan }) => {
      return sendPlanInquiryMail({ name, email, plan });
    },
    onSuccess,
    onError
  });
};

export default useSendPlanInquiryMail;
